import { render, staticRenderFns } from "./Contact-us.vue?vue&type=template&id=b401a18c&scoped=true&"
import script from "./Contact-us.vue?vue&type=script&lang=js&"
export * from "./Contact-us.vue?vue&type=script&lang=js&"
import style0 from "./Contact-us.vue?vue&type=style&index=0&id=b401a18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b401a18c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VCard,VContainer,VIcon})
